import { useState } from "react";
import { ToolOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { OperationsModal } from "./tables/operations/OperationsModal";

/**
 * „Фискални операции" на ПИН екрана — отваря СЪЩИЯ `OperationsModal` като
 * „Опции" → „Фискални операции" в Маркиране. Без право: заявките вървят с
 * токена на общия терминал, който BE пуска без `fiscal_operations`
 * (`require_permission_or_shared_terminal`).
 */
export default function KeypadOperationsButton({
  onOpenChange,
}: {
  /** Клавиатурата спира да трупа клавиши в кода, докато модалът е отворен. */
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const label = t("ordering.operations");

  const setModalOpen = (next: boolean) => {
    setOpen(next);
    onOpenChange(next);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        title={label}
        aria-label={label}
        className="inline-flex h-[calc(var(--u)*36)] shrink-0 items-center gap-[calc(var(--u)*6)] rounded-[calc(var(--u)*10)] border border-shade-3 bg-transparent px-[calc(var(--u)*12)] text-[length:calc(var(--u)*13)] font-semibold text-pos-body hover:bg-surface/60 transition"
      >
        <ToolOutlined className="text-[length:calc(var(--u)*13)]" />
        <span className="hidden sm:inline">{label}</span>
      </button>
      <OperationsModal open={open} onClose={() => setModalOpen(false)} />
    </>
  );
}
